













import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class CustomLink extends Vue {
  @Prop({ type: String, default: undefined }) readonly href?: string
  @Prop({ type: String, default: '' }) readonly dataAction?: string
  @Prop({ type: Boolean, default: false }) readonly small?: boolean
  @Prop({ type: Boolean, default: false }) readonly error?: boolean
  @Prop({ type: Boolean, default: false }) readonly bold?: boolean
  @Prop({ type: String, default: '' }) readonly target?: string
  @Prop({ type: Boolean, default: false }) readonly underline?: string

}
